export default "__VITE_ASSET__C4YU70Ju__"